import { render } from "./ImgThumbnail.vue?vue&type=template&id=67e4fae5"
import script from "./ImgThumbnail.vue?vue&type=script&lang=js"
export * from "./ImgThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bapman/Sites/telemac-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__